module.exports = __webpack_public_path__ + "img/smart-charging.66b84339.png";